import { HttpErrorResponse, HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { Router } from '@angular/router';
import { AuthenticationService, AuthenticationStore } from '@pflegix/authentication';
import { MessageCode } from '@pflegix/types';
import { catchError, switchMap, throwError } from 'rxjs';

function signOut(): void {
  const authService = inject(AuthenticationService);
  const router = inject(Router);
  const authStore = inject(AuthenticationStore);

  authService.logOut();
  authStore.unsetUser();
  router.navigate(['/login']);
}

export const unauthenticatedInterceptor: HttpInterceptorFn = (req, next) => {
  const authService = inject(AuthenticationService);

  return next(req).pipe(
    catchError((error: HttpErrorResponse) => {
      if (error.error?.code === MessageCode.ACCESS_TOKEN_EXPIRED) {
        return authService.refreshAccessToken().pipe(
          // eslint-disable-next-line camelcase
          switchMap(({ access_token }) => {
            const newRequest = req.clone({
              // eslint-disable-next-line camelcase
              setHeaders: { Authorization: `Bearer ${access_token}` },
            });

            // eslint-disable-next-line camelcase
            authService.accessToken = access_token;

            return next(newRequest);
          }),
          catchError((err: HttpErrorResponse) => {
            signOut();

            return throwError(() => err);
          })
        );
      }

      if (error.status === 401) {
        signOut();
      }

      return throwError(() => error);
    })
  );
};
